module.exports = __webpack_public_path__ + "static/media/SingleCoupon_detailTitle.5fbbe614.png";